export const PERMISSIONS_ROUTES = {
  __ROOT__: '/permissions',
}
